export function shouldClearUnavailableStaff({
  canReassignStaff,
  selectedStaffId,
  availableStaffIds,
  keepStaffId,
}: {
  canReassignStaff: boolean;
  selectedStaffId: string;
  availableStaffIds: number[];
  keepStaffId?: number | null;
}) {
  if (keepStaffId != null && Number(selectedStaffId) === keepStaffId) {
    return false;
  }

  return (
    canReassignStaff &&
    selectedStaffId.length > 0 &&
    !availableStaffIds.includes(Number(selectedStaffId))
  );
}

export function visibleStaffForService<T extends { id: number; active?: boolean }>({
  staff,
  eligibleStaffIds,
  keepStaffId,
}: {
  staff: T[];
  eligibleStaffIds?: number[] | null;
  keepStaffId?: number | null;
}): T[] {
  const bookable = staff.filter(
    (member) => member.active !== false || member.id === keepStaffId,
  );
  if (!eligibleStaffIds || eligibleStaffIds.length === 0) return bookable;

  return bookable.filter(
    (member) =>
      eligibleStaffIds.includes(member.id) || member.id === keepStaffId,
  );
}
